<template>
  <v-menu
    v-model="showPicker"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateFormatted"
        :label="label"
        append-icon="date_range"
        readonly
        hide-details
        placeholder=" "
        clearable
        v-on="on"
        :value="dateIn"
        @click:clear="clearDate()"
        @click:append="showPicker = true;"
        >
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      no-title
      @input="showPicker = false;"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import { formatDate } from '@/components/Mixins/formatDate'

export default {
  name: 'DateInput',
  props: {
    dateName: {
      type: String
    },
    dateIn: {
      type: String,
      default: null
    }
  },
  mixins: [formatDate],
  data () {
    return {
      date: this.dateIn,
      dateFormatted: this.formatDate(this.dateIn),
      showPicker: false
    }
  },
  computed: {
    label () {
      return this.capitalize(this.dateName.replace('_', ' '))
    }
  },
  watch: {
    date (val) {
      this.dateFormatted = this.formatDate(this.date)
      this.updateDate()
    }
  },
  methods: {
    clearDate () {
      this.date = ''
      this.updateDate()
    },
    updateDate () {
      this.$emit('update-date', {
        dateName: this.dateName,
        dateOut: this.date
      })
    },
    capitalize (s) {
      if (typeof s !== 'string') return ''
      return s.charAt(0).toUpperCase() + s.slice(1)
    }
  }
}
</script>
